// JSON is the only task configuration source. null means missing configuration.
export function dailyRate(daily, date) {
  const key = date instanceof Date ? date.toISOString().slice(0, 10).replaceAll('-', '')
    : String(date ?? 'default').slice(0, 10).replaceAll('-', '');
  const value = daily?.[key] ?? daily?.default;
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
